// extracted by mini-css-extract-plugin
export default {"root":"FacilitiesSection_root__PhFH2","loader-root":"FacilitiesSection_loader-root__91xq+","cards":"FacilitiesSection_cards__-5TsK"};